// src/SeoHead.jsx
import React from "react";
import { Helmet } from "react-helmet";

export default function SeoHead({
  title = "A & M Audio — Car Audio Installations",
  description = "Veteran-owned car audio installs: head units, amps, subs, speakers, backup cameras, precise tuning.",
  url = "https://www.am-audio.netlify.app",
  image = "/hero.jpg",
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:title" content={title}/>
      <meta property="og:description" content={description}/>
      <meta property="og:url" content={url}/>
      <meta property="og:image" content={image}/>
      <meta property="og:type" content="website"/>
      <meta name="twitter:card" content="summary_large_image"/>
    </Helmet>
  );
}
